import type { NotificationProps as CustomNotificationProps } from '@myosh/odin-components';
import { Notification } from '@myosh/odin-components';
import ReactDOM from 'react-dom';
import type { ToastOptions } from 'react-hot-toast';
import { useToaster } from 'react-hot-toast';

export interface NotificationProps
  extends ToastOptions,
    Pick<CustomNotificationProps, 'showCloseIcon' | 'onCloseClick'> {}

interface NotificationsProps {
  appendTo?: HTMLElement;
  toasterId?: string;
}

const Notifications = ({ appendTo, toasterId }: NotificationsProps) => {
  const { toasts, handlers } = useToaster({}, toasterId);
  const { startPause, endPause, calculateOffset, updateHeight } = handlers;

  const createNotifications = () => {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          display: 'flex',
          width: '100%',
          zIndex: 9999,
          flex: '0 1 auto',
          justifyItems: 'center',
        }}
        onMouseEnter={startPause}
        onMouseLeave={endPause}
      >
        {toasts.map((toast) => {
          const offset = calculateOffset(toast, { reverseOrder: false, gutter: 8 });

          const ref = (el: HTMLDivElement) => {
            if (el && !toast.height) {
              const height = el.getBoundingClientRect().height;
              updateHeight(toast.id, height);
            }
          };

          return (
            <Notification
              key={toast.id}
              ref={ref}
              {...toast.ariaProps}
              className="max-w-sm"
              style={{
                position: 'absolute',
                left: '50%',
                top: '1rem',
                transition: 'all 0.5s ease-out',
                opacity: toast.visible ? 1 : 0,
                transform: `translate(-50%, ${offset}px)`,
                zIndex: 9999999,
              }}
              type={toast.type}
            >
              {String(toast.message)}
            </Notification>
          );
        })}
      </div>
    );
  };

  return ReactDOM.createPortal(createNotifications(), appendTo ?? document.body);
};

export default Notifications;
